/**
 * URL base de la api
 */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

/**
 * Obtener headers de autenticación con Bearer token
 */
export const getAuthHeaders = () => {
    const token = localStorage.getItem('authToken');
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

/**
 * Obtener ID de usuario desde localStorage
 */
export const getUserId = () => {
    const userId = localStorage.getItem('user_id');

    if (userId && userId !== 'undefined' && userId !== 'null') {
        return userId;
    }

    // Fallback para sesiones donde solo quedó persistido el objeto user
    const rawUser = localStorage.getItem('user');
    if (!rawUser) {
        return null;
    }

    try {
        const parsedUser = JSON.parse(rawUser);
        const resolvedId =
            parsedUser?.cognito_sub ||
            null;
        return resolvedId;
    } catch (error) {
        console.error('Error al parsear user para getUserId: ', error);
        return null;
    }
};

/**
 * Obtener ID del taller seleccionado
 */
export const getWorkshopId = () => {
    const workshopData = localStorage.getItem('selectedWorkshop');
    if (!workshopData) return null;

    try {
        const workshop = JSON.parse(workshopData);
        return workshop._id;
    } catch (error) {
        console.error('Error al parsear selectedWorkshop: ', error);
        return null;
    }
};

/**
 * Obtener token de autenciación
 */
export const getAuthToken = () => {
    return localStorage.getItem('authToken');
};

/**
 * Obtener refresh token
 */
export const getRefreshToken = () => {
    return localStorage.getItem('refreshToken');
};

/**
 * Guardar sesión completa (después de login/register)
 */
export const saveSession = (sessionData, userData) => {
    const resolvedUserId =
        userData?.cognito_sub ||
        null;

    localStorage.setItem('authToken', sessionData.access_token);
    localStorage.setItem('refreshToken', sessionData.refresh_token);

    if (resolvedUserId) {
        localStorage.setItem('user_id', resolvedUserId);
    } else {
        localStorage.removeItem('user_id');
    }

    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('isLogin', 'true');

    // Calcular expiración ya que la sessionData.expires_in está en segundos
    const expiryTime = Date.now() + (sessionData.expires_in * 1000);
    localStorage.setItem('sessionExpiry', expiryTime.toString());
};

/**
 * Limpiar sessión completa
 */
export const clearSession = () => {
    localStorage.removeItem('isLogin');
    localStorage.removeItem('sessionExpiry');
    localStorage.removeItem('user');
    localStorage.removeItem('workshops');
    localStorage.removeItem('selectedWorkshop');
    localStorage.removeItem('user_id');
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('rol');
};

/** 
 * Verificar si la sesión está activa
*/
export const isSessionActive = () => {
    const login = localStorage.getItem('isLogin');
    const expiry = localStorage.getItem('sessionExpiry');

    if (login === 'true' && expiry && Date.now() < Number(expiry)) return true;

    return false;
};